import { useQuery } from '@tanstack/react-query'
import { Button, TabBar } from '@viapeople/components'
import { Outlet, useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom'
import { trpc } from '../../../utils/trpc'
import type { Cycle, Organization } from '../types'

const tabs = [
	{ id: 'configuration', label: 'Configuration' },
	{ id: 'list', label: 'Rater List' },
	{ id: 'unsolicited', label: 'Unsolicited' },
	{ id: 'instructions', label: 'Instructions' },
]

export function CycleReviewersTab() {
	const { organizationId, cycleId } = useParams<{ organizationId: string; cycleId: string }>()
	const navigate = useNavigate()
	const location = useLocation()
	const { organization, cycle } = useOutletContext<{ organization: Organization; cycle: Cycle }>()
	const pathArray = location.pathname.split('/')
	//TODO: Improve this
	const currentTab = pathArray?.[6] ?? 'configuration'

	const { data: groups } = useQuery({
		...trpc.admin.cycles.reviewerGroups.search.queryOptions({
			cycleId: cycleId as string,
			search: '',
			perPage: 99999,
		}),
		enabled: !!cycleId,
	})

	const handleTabChange = (tabId: string) => {
		navigate(`/organizations/${organizationId}/cycles/${cycleId}/reviewers/${tabId}`)
	}

	return (
		<div>
			<div className='bg-neutral-0 rounded-lg px-6 pb-6 mt-6 shadow-table'>
				<div className='flex justify-between items-center'>
					<TabBar tabs={tabs} activeTab={currentTab} onChange={handleTabChange} />
					{currentTab === 'list' && !!groups?.data?.length && (
						<div className='flex gap-2'>
							{cycle?.status === 'in-progress' && (
								<Button
									variant='secondary'
									onClick={() => {
										navigate(`/organizations/${organizationId}/cycles/${cycleId}/reviewers/list/add`)
									}}>
									Add Raters
								</Button>
							)}
							<Button
								onClick={() => {
									navigate(`/organizations/${organizationId}/cycles/${cycleId}/reviewers/list/upload`)
								}}>
								Upload File
							</Button>
						</div>
					)}
				</div>
				<Outlet context={{ organization, cycle }} />
			</div>
		</div>
	)
}
